//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { UsesAuthenticatedUser, UsesDashboardLinks, UsesGroupQueryString, UsesKintellGroup } from '@/mixins'
import { get } from 'vuex-pathify'

export default {
  mixins: [ UsesAuthenticatedUser, UsesDashboardLinks, UsesKintellGroup, UsesGroupQueryString ],

  props: {
    pages: {
      type: Object,
      required: true
    },
  },

  data: () => ({
    isActive: false,
  }),

  computed: {
    ...get({
      awaitingBookingSession: 'myKintell/awaitingBookingSession',
      activeDashboardTabIndex: 'myKintell/activeDashboardTabIndex'
    }),
    activeDashboardTab () {
      if (this.activeDashboardTabIndex === -1) {
        return []
      }
      return this.dashboardLinks[this.activeDashboardTabIndex]
    },
    alertCount () {
      return this.authenticatedUser ?? this.authenticatedUser.stats.alerts + (this.authenticatedUser.stats.bookingActive ? 1 : 0)
    },
    styles () {
      return {
        width: '100%',
        transform: `translateX(${this.isActive ? 0 : 100}%)`
      }
    },
    discoverLinks () {
      return [
        { key: 'knowledgeMarketplace', path: this.pages.marketplace },
        { key: 'forBusiness', path: this.pages.forBusiness },
        { key: 'useCases', path: '/articles/category/use-cases' },
        { key: 'pricing', path: this.pages.pricing },
      ]
    },
    featureLinks () {
      return [
        { key: 'featureVideo', path: this.pages.featureVideo },
        { key: 'featureCalendar', path: this.pages.featureCalendar },
        { key: 'featurePay', path: this.pages.featurePay },
        { key: 'featureCards', path: this.pages.featureCards },
      ]
    },
    hasKintellGroups () {
      return this.kintellGroups?.length || false
    },
    kintellGroups () {
      return this.authenticatedUser?.kintellGroups
    },
    myDashboardLinks () {
      return this.dashboardLinks.filter(item => item && item.name)
    },
  },

  methods: {
    toggleClose (item) {
      this.activeDashboardTab = item
      this.isActive = false
    }
  }
}
